import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface ToastMessage {
  id: number;
  message: string;
  type: "success" | "error" | "warning" | "info";
}

@Injectable({
  providedIn: "root",
})
export class ToastServicee {
  private toastSubject = new BehaviorSubject<ToastMessage[]>([]);

  toasts$ = this.toastSubject.asObservable();

  private toastId = 0;

  show(
    message: string,
    type: "success" | "error" | "warning" | "info" = "info",
  ) {
    const id = ++this.toastId;

    const toast: ToastMessage = {
      id,
      message,
      type,
    };

    this.toastSubject.next([...this.toastSubject.value, toast]);

    // Automatically remove after 4 seconds
    setTimeout(() => {
      this.remove(id);
    }, 4000);
  }

  success(message: string) {
    this.show(message, "success");
  }

  error(message: string) {
    this.show(message, "error");
  }

  warning(message: string) {
    this.show(message, "warning");
  }

  info(message: string) {
    this.show(message, "info");
  }

  remove(id: number) {
    this.toastSubject.next(
      this.toastSubject.value.filter((toast) => toast.id !== id),
    );
  }
}
